import { useQuery } from 'hooks/useCustomQuery';
import { useDispatch } from 'react-redux';
import getAllWholesalers from '@/API/Wholesaler/getAllWholesalers';

const useGetAllWholesalers = (setTableData) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['wholesalers'],
        queryFn: getAllWholesalers,
        onSuccess: (data) => {
            const sortedData = [...(data || [])].sort((a, b) =>
                (a?.name || '').localeCompare(b?.name || ''),
            );

            setTableData((prev) => ({
                ...prev,
                data: sortedData,
            }));
            dispatch({ type: 'CHANGE_TABLE_LOADING' });
        },
        staleTime: 1000 * 60 * 5,
    });
};

export default useGetAllWholesalers;
